import { CLOSED_APPOINTMENT_STATUSES } from 'modules/common/constants/appointmentStatuses';
import { changePatientInfoTab } from 'modules/appointmentInfo/actions/changePatientInfoTab';
import { updateAppointmentGroupCurrentAppointment } from 'modules/appointmentInfo/actions/updateAppointmentGroupCurrentAppointment';
import { replaceTo } from 'modules/auth/actions/redirectAction';

import createAction from '.';
import { hideAppointmentInfo } from './appointmentInfo';


export const ADD_GROUP_APPOINTMENT_TO_SCOPE = createAction('ADD_GROUP_APPOINTMENT_TO_SCOPE');

export const onGroupAppointmentsUpdates = ({ err, data }) => (dispatch, getState) => {
  if (err) throw (err);

  const group = data.appointmentGroupUpdate;
  const state = getState();
  const { currentAppointment } = state.appointmentInfo;
  const { isAppointmentInfoShown } = state.queues.common.appointmentInfo;

  if (!!currentAppointment.group && group.groupId === currentAppointment.group.groupId && isAppointmentInfoShown) {
    const tempApptGroup = group.appointments.filter(
      tempAppt => !CLOSED_APPOINTMENT_STATUSES.includes(tempAppt.status),
    );

    const prevAppTGroup = currentAppointment.group.appointments.filter(
      tempAppt => !CLOSED_APPOINTMENT_STATUSES.includes(tempAppt.status),
    );

    const currIndex = prevAppTGroup.findIndex(({ appointmentId }) => currentAppointment.appointmentId === appointmentId);

    let nextAppointmentId;

    if (tempApptGroup.length && prevAppTGroup.length) {
      nextAppointmentId = prevAppTGroup[currIndex + 1]
        ? prevAppTGroup[currIndex + 1].appointmentId
        : prevAppTGroup[0].appointmentId;
    }

    group.appointments.map(updatedAppointment =>
      currentAppointment.group.appointments.map(oldAppointment => {
        if (updatedAppointment.appointmentId === currentAppointment.appointmentId
          && updatedAppointment.appointmentId === oldAppointment.appointmentId
          && updatedAppointment.status !== oldAppointment.status) {
          if (CLOSED_APPOINTMENT_STATUSES.includes(updatedAppointment.status)) {
            if (tempApptGroup.length) {
              dispatch(updateAppointmentGroupCurrentAppointment(nextAppointmentId))
                .then(() => {
                  if (window.location.href.includes(updatedAppointment.appointmentId)) {
                    replaceTo('/appointments');
                  }
                });
              dispatch(changePatientInfoTab('1'));
            } else {
              dispatch(hideAppointmentInfo());
              if (window.location.href.includes('/appointment/update')) {
                replaceTo('/appointments');
              }
            }
          }
        }
      }),
    );
  }
  dispatch({ type: ADD_GROUP_APPOINTMENT_TO_SCOPE, payload: data.appointmentGroupUpdate });
};
